export enum ProfileType {
	University = '9a783c9d-6f22-4785-8be7-f45c090d2550',
	School = '9a783cab-4e79-4e75-a294-e4d2871f7040',
	Multitenant = '9a783c8d-a166-4a40-9766-4936fc5777a4',
	OperationalUnit = '9a783c12-5f3b-4d2e-9a86-3f73e0e920be',
	HospitalCompany = '9a783c55-7d1e-4f1a-a927-b7a8c4d6a2ee',
	HospitalLocation = '9a783c9c-cc0b-44d7-b3de-5271e63a4a79',
	ScientificSector = '9a783c0e-f21a-4ff4-96e1-499b7a19c6a2',
	Trainee = '9a783cdd-1234-4567-8901-abcdef123456',
	Student = '9a783cde-1234-4567-8901-abcdef123456',
	CoordinatingTeacher = '9a783cee-1234-4567-8901-abcdef123456',
	InternshipSecretary = '9a783cff-1234-4567-8901-abcdef123456',
}
